/**
 * Máscara / sanitização para nome do terceiro.
 * Regras:
 * - 2–60 caracteres (validação)
 * - permite letras (incluindo acentos), espaços, hífen e apóstrofo
 * - remove espaços extras no início/fim (trim) e colapsa múltiplos espaços
 * - não permite números ou outros símbolos
 */

import {
  normalizarNome,
  sanitizarNome
} from "../../domain/rules/normalizadores.js";

export { normalizarNome, sanitizarNome };

/**
 * Sanitiza nome: mantém só letras acentuadas, espaço, hífen, apóstrofo.
 * Colapsa espaços múltiplos, remove números/símbolos.
 * @param {*} valor
 * @returns {string}
 */
/**
 * Aplica máscara incremental para nome (para @input).
 * Não remove números aqui – deixa validador exibir erro "não pode conter números".
 * Apenas colapsa espaços duplos; não limita aqui para validação detectar >60.
 * @param {*} valor
 * @returns {string}
 */
export function aplicarMascaraNome(valor) {
  if (valor === null || valor === undefined) return "";
  let texto = String(valor);
  // Não remove números nem símbolos aqui para validação exibir erro;
  // apenas colapsa espaços duplos
  texto = texto.replace(/\s{2,}/g, " ");
  // Evita começar com espaço, hífen ou apóstrofo
  if (texto.length === 1 && /^[\s'-]$/.test(texto)) return "";
  return texto;
}

/**
 * Normaliza nome para salvar: trim + colapsa espaços + limita 60.
 * @param {*} valor
 * @returns {string}
 */
